import ChatInboxPage from './ChatInboxPage';

export default ChatInboxPage;
